// extracted by mini-css-extract-plugin
export default {"div":"EventsLiked_div__pKcSH","card":"EventsLiked_card__hHX-5"};